import { useCallback } from 'react';
import useAsync from './useAsync';

const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const useCheckout = () => {
  const { execute, isLoading, error } = useAsync();

  const startCheckout = useCallback((items, customer) => execute(async () => {
    const response = await fetch(`${backendUrl}/api/checkout/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items.map(item => ({ id: item.id, quantity: item.quantity })),
        customer,
      }),
    });
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || 'Checkout could not be started.');
    }

    if (!result.url) {
      throw new Error('Stripe did not return a checkout link.');
    }

    window.location.assign(result.url);
    return result;
  }), [execute]);

  return {
    startCheckout,
    isCheckingOut: isLoading,
    checkoutError: error ? error.message : '',
  };
};

export default useCheckout;
